/**
 * Product image URL helper.
 *
 * Prefers an explicit `image_url` set on the product (may be a full URL from an
 * external source like Shopify, OR a relative `/api/shop/media/{id}` path from
 * SociBaba's Content Library — we prefix the backend base for the latter).
 * Falls back to a curated pool of 8 sample product photos (see
 * `sampleImages.ts`) that rotate deterministically per product-id so the
 * browse grid feels rich AND the SmartImage skeleton has variety to show
 * off graceful staggered loading. The same product always renders the
 * same photo across sessions.
 */
import { sampleImageFor } from "@/lib/sampleImages";
export { sampleImageFor, sampleBlurFor } from "@/lib/sampleImages";

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export function productImage(
  p: {
    image_url?: string | null;
    slug?: string | null;
    product_id?: string | null;
    title?: string | null;
  },
  size: number = 600,
): string {
  const url = p.image_url;
  if (url) {
    if (url.startsWith("/")) return `${BACKEND}${url}`;
    return url;
  }
  const seed = p.slug || p.product_id || p.title || "socibaba-product";
  return sampleImageFor(seed, size);
}
